<script lang="ts">
  import { cn } from '@shared/utils';

  import PaginationAndLoadMore from './pagination-loadMore.svelte';

  type PaginationAction = (params: { page: number; loadMore?: number }) => Promise<void>;

  export let pageSize: number;

  // MUST bind to:
  export let loading = false;
  export let totalDataCount: number;
  export let containerToScroll: HTMLElement | undefined;
  export let requestFunction: PaginationAction;
  export let loadMoreFunction: PaginationAction;
  export let isFullWidth = false;

  export let currentPage = 1;
  export let loadMore = 0;

  let sectionElement: HTMLElement;

  async function pageChangeHandler(event: CustomEvent) {
    loading = true;

    currentPage = event.detail.currentPage || 1;
    loadMore = event.detail.loadMore || 0;

    await requestFunction({ page: currentPage, loadMore });

    if (containerToScroll) window.scrollTo({ top: containerToScroll.offsetTop - 100, behavior: 'smooth' });

    loading = false;
  }

  async function loadMoreHandler(event: CustomEvent) {
    loading = true;

    currentPage = event.detail.currentPage || 1;
    loadMore = event.detail.loadMore || 0;

    await loadMoreFunction({ page: currentPage, loadMore });

    loading = false;
  }
</script>

<section
  bind:this="{sectionElement}"
  class="{cn(
    'relative after:pointer-events-none after:absolute after:bottom-10 after:left-0 after:right-0 after:top-0 after:block after:w-full after:opacity-0',
    {
      'after:bg-whitish after:pointer-events-auto after:opacity-100 after:backdrop-blur-[1px]': loading,
      'after:-left-5 after:-right-5 after:w-auto md:after:-left-8 md:after:-right-8 xl:after:-left-12 xl:after:-right-12':
        isFullWidth,
    },
  )}"
>
  <slot />
  <PaginationAndLoadMore
    totalItems="{totalDataCount}"
    bind:currentPage
    bind:loadMore
    {pageSize}
    on:onPageChange="{pageChangeHandler}"
    on:onLoadMore="{loadMoreHandler}"
  />
</section>
